import { useMemo } from 'react';
import { useUserInfo } from './useUserInfo';
const useGates = () => {
  const userInfo = useUserInfo();
  const gates = useMemo(() => new Set(userInfo === null || userInfo === void 0 ? void 0 : userInfo.gates), [userInfo]);
  return gates;
};
export const useGate = gate => useGates().has(gate);